<template>
  <div class="bonus-calc">
    <div class="bonus-calc--container">
      <div class="bonus-calc__inner">
        <h1 class="bonus-calc-title">
          {{ $t("BonusCalc.Title") }}
        </h1>
        <div class="bonus-calc-content">
          <div class="bonus-calc-content__wrapper">
            <ol class="bonus-calc-list">
              <li class="bonus-calc-list__item">
                <FamilyButtons
                  v-model="countPeople"
                  :title="$t('BonusCalc.FamilySize')"
                  @change-count="updateCountPeople"
                />
              </li>
              <li class="bonus-calc-list__item">
                <Slider
                  :title="$t('BonusCalc.PurchaseAmount')"
                  :amount="amountPurchases"
                  :sliderValues="purchasesSliderValues"
                  :masksInputSlider="masksInputSlider"
                  purchases
                  @change-deposit="updateAmountPurchases"
                />
              </li>
            </ol>
          </div>

          <div class="bonus-calc__equals">
            <img :src="require('@/assets/img/equals.png')" alt="" />
          </div>

          <!-- Result -->
          <div class="bonus-calc__right">
            <div class="bonus-card">
              <div class="bonus-card__left">
                <h4 class="bonus-card__title">{{ $t("BonusCalc.PointsEarned") }}</h4>
                <div class="bonus-card__counters">
                  <div class="bonus-card__count">
                    <p>{{ $t("BonusCalc.Month") }}</p>
                    <h3>
                      {{ `${formattedBonusMonth} ${$t("BonusCalc.ShortScore")}*` }}
                    </h3>
                  </div>
                  <div class="bonus-card__count">
                    <p>{{ $t("BonusCalc.Year") }}</p>
                    <h3>
                      {{ `${bonusYear} ${$t("BonusCalc.ShortScore")}*` }}
                    </h3>
                  </div>
                </div>
                <a href="#" class="bonus-card__btn btn-calc btn-calc_primary">
                  {{ $t("BonusCalc.BecomeClient") }}
                </a>
                <p class="bonus-card__txt">* {{ $t("BonusCalc.OfferText") }}</p>
              </div>
              <img
                class="bonus-card__image"
                :src="require('@/assets/img/calc-pig.png')"
                alt="piggy bank"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/Slider";
import FamilyButtons from "@/components/FamilyButtons";

export default {
  name: "BonusCalc",
  components: {
    FamilyButtons,
    Slider,
  },
  data() {
    return {
      countPeople: 1,
      amountPurchases: 20000,
      purchasesSliderValues: {
        step: 1000,
        min: 10000,
        max: 150000,
        initialValue: 20000,
        symbol: "₽",
        range: {
          min: [10000],
          max: [150000],
        },
      },
    };
  },
  computed: {
    masksInputSlider() {
      return [
        `### ### ${this.purchasesSliderValues.symbol}`,
        `## ### ${this.purchasesSliderValues.symbol}`,
        `# ### ${this.purchasesSliderValues.symbol}`,
        `### ${this.purchasesSliderValues.symbol}`,
      ];
    },
    bonusPerMonth() {
      return (this.amountPurchases * this.percentFamily) / 100;
    },
    bonusYear() {
      return (this.bonusPerMonth * 12).toLocaleString("ru-RU");
    },
    formattedBonusMonth() {
      return this.bonusPerMonth.toLocaleString("ru-RU");
    },
    percentFamily() {
      if (this.amountPurchases >= 10000 && this.amountPurchases < 50000) return 1.5;
      if (this.amountPurchases >= 50000 && this.amountPurchases < 75000) return 2;
      return 2.5;
    },
  },
  methods: {
    updateCountPeople(value) {
      if (value === 1) this.amountPurchases = 10000;
      if (value === 2) this.amountPurchases = 50000;
      if (value === 3) this.amountPurchases = 75000;
    },
    updateAmountPurchases(value) {
      this.amountPurchases = value;
      if (value < 30000) this.countPeople = 1;
      if (value >= 50000 && value < 75000) this.countPeople = 2;
      if (value >= 75000) this.countPeople = 3;
    },
  },
};
</script>

<style lang="scss" scoped>
.bonus-calc {
  background: var(--main-bg-color);

  &__inner {
    padding: 56px;
  }

  &-title {
    font-weight: 500;
    font-size: 44px;
    line-height: 52px;
  }

  &__right {
    width: 100%;
    max-width: 600px;
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 32px;
    gap: 32px;

    &__wrapper {
      margin-bottom: 36px;

      @media (min-width: 1130px) {
        margin-bottom: 0;
      }
    }

    @media (min-width: 1130px) {
      flex-direction: row;
      justify-content: space-between;
      margin-top: 48px;
    }
  }

  &-checkboxes {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 45px;

    label {
      display: flex;
      align-items: center;
      font-style: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.2px;
      color: var(--main-black-text);

      p {
        margin-left: 15px;
      }

      &:first-child {
        margin-bottom: 15px;
      }

      @media (min-width: 1130px) {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;

        &:first-child {
          margin-right: 55px;
        }
      }
    }

    @media (min-width: 1130px) {
      flex-direction: row;
    }
  }

  &-list {
    counter-reset: myCounter;
    width: 100%;
    max-width: 604px;

    &__item {
      position: relative;
      display: flex;
      list-style: none;
      padding-bottom: 32px;
      width: 100%;

      &::before {
        counter-increment: myCounter;
        content: counter(myCounter);
        z-index: 1;
        display: inline-block;
        margin-right: 16px;
        border-radius: 50%;
        width: 44px;
        height: 44px;
        font-size: 24px;
        line-height: 44px;
        text-align: center;
        color: #fff;
        background: #6d9fff;
        transform: translate(0, -5px);
      }

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        left: 22px;
        border-left: 2px dashed var(--light-gray);
        height: 100%;
      }

      &:nth-child(2),
      &:nth-child(7) {
        &::before {
          background-color: var(--light-orange);
        }
      }

      &:nth-child(3) {
        &::before {
          background-color: var(--light-blue);
        }
      }

      &:nth-child(4) {
        &::before {
          background-color: var(--light-red);
        }
      }

      &:nth-child(5) {
        &::before {
          background-color: var(--green);
        }
      }
    }

    @media (min-width: 1130px) {
      margin-right: 20px;
    }
  }
}

.bonus-card {
  position: relative;
  z-index: 1;
  overflow: hidden;
  border-radius: 18px;
  padding: 32px;
  background: #fff;

  &__left {
    max-width: 455px;
  }

  &__txt {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #818c99;
  }

  &__counters {
    display: flex;
    justify-content: space-between;
    margin-bottom: 64px;
    max-width: 80%;
  }

  &__title {
    margin-bottom: 32px;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
  }

  &__count {
    p {
      margin-bottom: 4px;
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
      color: #818c99;
    }

    h3 {
      font-weight: 600;
      font-size: 32px;
      line-height: 40px;
    }
  }

  &__btn {
    display: inline-flex;
    margin-bottom: 24px;
    padding: 24px 32px;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
  }

  &__image {
    position: absolute;
    right: 0;
    top: 60%;
    z-index: -1;
    width: 180px;
    height: 250px;
    object-fit: contain;
    transform: translateY(-50%);
  }

  .btn-calc {
    position: relative;
    overflow: hidden;
    border: none;
    border-radius: 18px;
    transition: background 400ms;
    cursor: pointer;

    &_secondary {
      color: #2771fc;
      background-color: #fff;
    }

    &_outline {
      border: 1px solid #c1d3e3;
      font-weight: 400;
      color: #252628;
      background-color: transparent;
    }

    &_primary,
    &_active {
      box-shadow: 2px 6px 16px rgba(60, 102, 210, 0.39);
      color: #fff;
      background-color: #2771fc;
    }
  }

  span.ripple {
    position: absolute;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.7);
    transform: scale(0);
    animation: ripple 600ms linear;
  }

  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(4);
    }
  }
}

@media screen and (max-width: 1300px) {
  .bonus-calc {
    &__equals {
      display: none;
    }
  }

  .bonus-card {
    &__counters {
      flex-direction: column;
      gap: 12px;
    }

    &__image {
      top: 40%;
    }
  }
}

@media screen and (max-width: 1130px) {
  .bonus-calc {
    &-content {
      align-items: flex-start;
      gap: 0;
    }
  }

  .bonus-card {
    padding: 24px 16px;
    height: auto;

    &__title {
      font-size: 18px;
      line-height: 24px;
    }

    &__counters {
      flex-direction: row;

      p {
        font-size: 16px;
        line-height: 24px;
      }

      h3 {
        font-size: 24px;
        line-height: 30px;
      }
    }

    &__btn {
      padding: 16px 24px;
    }

    &__image {
      width: 120px;
    }
  }
}

@media screen and (max-width: 768px) {
  .bonus-calc {
    &-title {
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
    }

    &__inner {
      padding: 32px 12px;
    }

    &-list {
      &__item {
        &::before {
          margin-right: 12px;
          width: 32px;
          height: 32px;
          font-weight: 500;
          font-size: 18px;
          line-height: 32px;
          transform: translate(0, -5px);
        }

        &:not(:last-child)::after {
          left: 16px;
        }
      }

      &__item + &__item {
        padding-bottom: 0;
      }
    }
  }

  .bonus-card {
    &__title {
      margin-bottom: 24px;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }

    &__counters {
      flex-direction: column;
      justify-content: flex-start;
      margin-bottom: 24px;
    }

    &__count {
      margin-bottom: 0;

      h3 {
        font-size: 20px;
        line-height: 28px;
      }
    }

    &__btn {
      width: 100%;
      font-size: 12px;
      line-height: 12px;

      &.btn-calc {
        border-radius: 8px;
      }
    }

    &__left {
      max-width: 100%;
    }

    &__image {
      top: 35%;
      width: 120px;
      height: 170px;
    }
  }
}
</style>
